import getApiClient from 'src/utils/getApiClient'

const apiClient = getApiClient()

export default {
  post(videoCardUuid: string) {
    return apiClient.post(
      `/api/lpu/video_card/${videoCardUuid}/view_count/`,
    )
  },
}
